import React, {useState} from 'react';
import {
    ConfigAddressApi,
    ConfigApi,
    MultistoreLayoutType,
    OrderType,
    PlaceApi,
    StoreConfigCoordinatesApi
} from "../../../../services/Api/types";
import MultistorePlaceCardCover from "./MultistorePlaceCardCover";
import MultistorePlaceCardFooter from "./MultistorePlaceCardFooter";
import {useNavigate} from "react-router-dom";
import StorageStore from "../../../../services/Common/Storage/storageStore";
import MultistoreOrderTypesModal from "../OrderTypesModal/MultistoreOrderTypesModal";
import {createKeyDownHandler} from "../../../../utils/keyDownHanlder";
import {RootState} from "../../../../../reducers";
import {getSession} from "../../../../services/Session/reducer";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import ChangeLocationMultistoreModal
    from "../../pages/HomePage/components/HomeWithMap/Old/ChangeLocationMultistoreModal";
import StringHelper from "../../../../services/Common/StringHelper";

interface OwnProps {
    place: PlaceApi;
    layout: MultistoreLayoutType;
    setHoveredPlace?: React.Dispatch<React.SetStateAction<PlaceApi | undefined>>;
    preventOnClick?: boolean;
    selectedOrderType?: OrderType;
    withoutDeliveryInfo?: boolean;
    config: ConfigApi;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistorePlaceCard = ({
                                 place,
                                 layout,
                                 setHoveredPlace,
                                 preventOnClick,
                                 selectedOrderType,
                                 withoutDeliveryInfo,
                                 config,
                                 session,
                             }: Props) => {
    const navigate = useNavigate();
    const [showOrderTypesModal, setShowOrderTypesModal] = useState(false);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const disabled = session.full_address && !place.in_delivery_zone && place.types.length === 1 && place.types[0] === OrderType.DELIVERY;

    const getProperPlaceLink = () => {
        let link = place.domain.replace(`${StorageStore.storeDomain}/`, "/");

        if (!link.startsWith('/')) {
            link = '/' + link;
        }

        return link;
    }

    const shouldForceAddressModal = (orderTypes: OrderType[]) => {
        if (session.full_address) return false;

        if (!selectedOrderType && orderTypes.length === 1 && orderTypes[0] === OrderType.DELIVERY ) {
            return true;
        }

        if (selectedOrderType === OrderType.DELIVERY) {
            return true;
        }

        return false;
    }

    const handleClick = () => {
        if (preventOnClick || disabled) return;

        const orderTypes = place.types;
        const link = getProperPlaceLink();

        if (orderTypes.length === 0) {
            navigate(link);
        } else if (orderTypes.length === 1) {
            if(shouldForceAddressModal(orderTypes) && setShowAddressModal) {
                setShowAddressModal(true);
                return;
            }
            navigate(`${link}/${orderTypes[0]}`);
        } else if (selectedOrderType) {
            navigate(`${link}/${selectedOrderType}`);
        } else {
            setShowOrderTypesModal(true);
        }
    }

    const handleOnKeyDown = () => createKeyDownHandler<HTMLDivElement>({
        keys: ["Enter", " "],
        preventDefault: true,
        action: handleClick
    });

    const handleHideLocationModal = (address: ConfigAddressApi, _: StoreConfigCoordinatesApi, errors: any[]) => {
        setShowAddressModal(false);

        const notInDeliveryAreaError = errors.find(error => error.code === "not_in_delivery_area");

        if(!notInDeliveryAreaError && StringHelper.getAddressName(address)) {
            navigate(`${getProperPlaceLink()}/DELIVERY`);
        }
    };

    return (
        <>
            <div className={`place-card ${disabled ? "disabled": ""}`} onClick={handleClick} tabIndex={0} role="button" onKeyDown={handleOnKeyDown()}
                 onMouseEnter={() => setHoveredPlace?.(place)}
                 onMouseLeave={() => setHoveredPlace?.(undefined)}
                 style={{cursor: preventOnClick ? "default" : "pointer"}}
            >
                <MultistorePlaceCardCover place={place} layout={layout} config={config}/>
                <MultistorePlaceCardFooter place={place} layout={layout} withoutDeliveryInfo={withoutDeliveryInfo}/>
            </div>
            {
                showOrderTypesModal && (
                    <MultistoreOrderTypesModal
                        orderTypes={place.types}
                        link={getProperPlaceLink()}
                        setShowAddressModal={setShowAddressModal}
                        session={session}
                        show={showOrderTypesModal}
                        onHide={() => setShowOrderTypesModal(false)}
                        place={place}
                    />
                )
            }
            {
                showAddressModal &&
                <ChangeLocationMultistoreModal showModal={showAddressModal}
                                               onHide={handleHideLocationModal}
                                               config={config} withoutGeolocation
                                               onChange={handleHideLocationModal}/>
            }
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MultistorePlaceCard));
